module.exports = __webpack_public_path__ + "static/video-journal-intro-6586345cb0f0639042e18b04919c477e.mp4";